let breakdowns = {
    name: "Аварии",
    path: "/#/breakdowns/list",
    target: true,
    meta: { icon_fa: "fas fa-bolt" },
    groups: ["TestMainGroup"],
}

export default breakdowns;